<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-4/12 px-4">
      <div
        class="relative flex flex-col break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16"
      >
        <div class="px-6">
          <h3
            class="text-xl font-semibold leading-normal mb-2 text-blueGray-700"
          >
            Send Us An Email
          </h3>
          <div class="mb-2 text-blueGray-600 mt-10">
            <i class="fas fa-envelope mr-2 text-lg text-blueGray-400"></i>
            <a href="mailto:admin@jawo.io">admin@jawo.io</a>
          </div>
          <div class="mb-2 text-blueGray-600">
            <i class="fas fa-envelope mr-2 text-lg text-blueGray-400"></i>
            <a href="mailto:management@jawo.io">management@jawo.io</a>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-4/12 px-4">
      <div
        class="relative flex flex-col break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16"
      >
        <div class="px-6">
          <h3
            class="text-xl font-semibold leading-normal mb-2 text-blueGray-700"
          >
            Call Us On
          </h3>
          <div class="mb-2 text-blueGray-600 mt-10">
            <i class="fas fa-phone mr-2 text-lg text-blueGray-400"></i>
            <a href="mailto:0802">08023456789</a>
          </div>
          <div class="mb-2 text-blueGray-600">
            <i class="fas fa-phone mr-2 text-lg text-blueGray-400"></i>
            <a href="mailto:0802">0802</a>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-4/12 px-4">
      <div
        class="relative flex flex-col break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16"
      >
        <div class="px-6">
          <h3
            class="text-xl font-semibold leading-normal mb-2 text-blueGray-700"
          >
            Chat With Us
          </h3>
          <div class="mb-2 text-blueGray-600 mt-10">
            <i class="fas fa-chat mr-2 text-lg text-blueGray-400"></i>
            chat
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import team2 from "@/assets/img/team-2-800x800.jpg";

export default {
  data() {
    return {
      team2,
    };
  }
};
</script>
